<template>
  <div id="ooowin" class="has-fix-top padding_top_80">
    <new-header></new-header>
    <div class="padding_top_40 w_bg">
      <div class="main_cont clearfix">
        <p class="breadcrumb cont_color margin_bottom_20"><a href="./index_news.html">专栏资讯</a><i class="padding_level_5">></i><span class="main_color">正文</span></p>
        <div class="fl left-cont border_gray_bottom margin_bottom_60">
            <p class="cont_title font_28 title_color margin_bottom_15">{{new_cont.title}}</p>
            <div class="time_box clearfix cont_color font_12  margin_bottom_60">
              <p class="fl cont_time padding_left_20 margin_right_20" v-if="false">{{new_cont.createTime ? new_cont.createTime.split(' ')[0]:''}}</p>
              <p class="fl cont_source padding_left_20">{{new_cont.newsSource}}</p>
            </div>
            <div class="news_info gray_bg title_color  font_18 margin_bottom_50" v-html="new_cont.intro"></div>
            <div class="margin_bottom_30">
                <tutorials
                        :tutor-content="new_cont.content"
                ></tutorials>
            </div>
            <div class="clearfix margin_bottom_40">
              <ul class="cont_label clearfix fr">
                <li v-for="inItem in new_cont.label" class="border_gray gray_bg border_radius_3 margin_left_20 padding_level_5">{{inItem}}</li>
              </ul>
            </div>
        </div>
        <div class="fr right-cont">
          <ul class="top_img margin_bottom_40"  v-if="top_img.length > 0">
            <li class="border_gray position_r cursor_p" v-for="(item,index) in top_img"
                :class="{'margin_bottom_20':index<top_img.length-1}"
              @click="getDetail(item.newsId)">
              <div class="img_width_100">
                <img :src="item.coverUrl"/>
                <p class="black_opacity_bg w_color position_a font_14 padding_level_20">{{item.title}}</p>
              </div>
            </li>
          </ul>
          <p class="left_icon position_r font_18 top_title_color padding_bottom_20 border_gray_bottom padding_left_20 margin_bottom_15">热门文章</p>
          <ul class="hot_news">
            <li v-for="item in hot_news" class="nowrap font_14 title_color margin_bottom_10 padding_left_20 position_r cursor_p" @click="getDetail(item.newsId)">{{item.title}}</li>
          </ul>
        </div>
        <div class="to_top border_gray gray_bg border_radius_3 cursor_p" :style="{left:to_top_left+'px'}" @click="toTop">
          <span></span>
        </div>
        <div class="share" :style="{left:share_left+'px'}">
          <a class="margin_bottom_10 border_radius_3 gray_bg qq_friend" :href="'https://connect.qq.com/widget/shareqq/index.html?&url='+encodeURIComponent(href)+'&title=STEM未来计划---'+new_cont.title+'&pics='+new_cont.coverUrl" target="_blank"><!--QQ分享-->
            <span></span>
          </a>
          <a class="margin_bottom_10 border_radius_3 gray_bg sina_share" :href="'http://v.t.sina.com.cn/share/share.php?url='+encodeURIComponent(href)+'&title=STEM未来计划---'+new_cont.title+'&pics='+new_cont.coverUrl" target="_blank"><!--新浪微博分享-->
            <span></span>
          </a>
          <a class="margin_bottom_10 border_radius_3 gray_bg qq_space" :href="'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url='+encodeURIComponent(href)+'&title=STEM未来计划---'+new_cont.title+'&sharesource=qzone&pics='+new_cont.coverUrl" target="_blank"><!--QQ空间分享-->
            <span></span>
          </a>
        </div>
      </div>

    </div>
    <PageFooter></PageFooter>
  </div>
</template>
<script>
import newHeader from '@components/common/newHeader.vue';
import PageFooter from '@components/common/PageFooter.vue';
import PageCenter from '@components/common/PageCenter.vue';
import tutorials from '@components/project/tutorials.vue';
export default {
  name: 'app',
  data(){
    return{
      top_img:[],
      hot_news:[],
      to_top_left:0,
      share_left:0,
      newsId:'',
      new_cont:{},
      href:'',
    //  tutorContent:null
    }
  },
  mounted:function (){
    let winW = window.innerWidth;
    let urlObj = this.getQueryObject();
    let share_left = winW/2-600-50-20 > 0 ? winW/2-600-50-20 : 0;
    this.to_top_left = winW<1200+140 ? winW-70 :winW/2+620;
    this.share_left = share_left;
    this.href = window.location.href;
    this.getTopNewes();
    this.getHotNews();
    this.newsId = urlObj.id||'';
    this.getOneDetail();
  },
  created:function(){

  },
  watch:{
    'new_cont.content'(){

    }
  },
  computed:{
  },
  methods:{
    getTopNewes(){
      this.ajax.get('web/news/topNewes',{}).then(res => {
          this.top_img = res.data || [];
      })
    },
    getHotNews(){
      this.ajax.get('web/news/hotNewes',{}).then(res => {
          this.hot_news = res.data || [];
      })
    },
    getOneDetail(){
      this.ajax.get('web/news/news/'+this.newsId,{}).then(res => {
          let data = res.data || {};
            data.intro = data.intro? data.intro.replace(/\n/g,'<br>').replace(/\s/g,'&nbsp;'): '';
            this.new_cont = data;

       // this.tutorContent = Base64.decode(res.data.content);
      })
    },
    getDetail(id){//去详情介绍
      window.location.href = './news_desc.html?id='+id;
    },
    toTop(){
      window.scroll(0,0);
    }
  },
  components:{
    PageFooter,PageCenter,newHeader,tutorials
  }
}
</script>
<style lang="scss" scoped>
    @import "./index.scss";
    .main_cont{
      font-size: 16px;
      .left-cont{
        padding: 0 5px 0 40px;
        box-sizing: border-box;
      }

    }
</style>
